import Vue from "vue";
import vSelect from "vue-select";
import Service from "@/api/Services/Service";
import "vue-select/dist/vue-select.css";

import { bus } from "@/main";
import { Component } from "vue-property-decorator";
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";
import { ResponseInterface } from "@/api/Interfaces/ResponseInterface";

const SelectServiceClinicProps = Vue.extend({
  props: {
    selectedServiceClinicName: {
      type: [Object as () => ServiceInterface],
      default: null,
    },
    placeholderTextDesktop: {
      type: String,
      default: "Buscar por um serviço, vacina ou exame",
    },
    placeholderTextMobile: {
      type: String,
      default: "Buscar por um serviço, vacina ou exame",
    },
    logo: {
      type: String,
      default: require("@/assets/images/logo_clinicarx.webp"),
    },
  },
});

@Component({
  name: "SelectServiceClinic",
  components: {
    "v-select": vSelect,
  },
})
export default class SelectServiceClinic extends SelectServiceClinicProps {
  cx_Services = new Service();
  cx_serviceClinicNames: Array<ServiceInterface> = [];
  cx_searchText: string | null = null;
  cx_logo: string = this.logo;
  cx_selectedServiceClinicName = this.selectedServiceClinicName;
  cx_isOpenMobileModal = false;
  clinicId = "";

  mounted(): void {
    this.getServicesClinicNames();
    this.clinicId = this.getCLinicId();
  }

  getCLinicId() {
    return this.$route.name == "ClinicScreen" ? this.$route.params.clinicId : "";
  }

  getServicesClinicNames(): void {
    this.cx_Services.listServices(this.clinicId).then((response) => {
      const responseData = response.data as ResponseInterface;
      this.cx_serviceClinicNames = responseData.data.data;
      bus.$emit("showLoading", false);
    });
  }

  toogleSearchModal($event: any = null): void {
    this.cx_searchText = "";

    if ($event != null) {
      $event.target.blur();
    }

    this.cx_isOpenMobileModal = !this.cx_isOpenMobileModal;
  }

  filterServiceClinicNames(): Array<ServiceInterface> {
    const text = this.cx_searchText ?? "";

    if (text == "") return this.cx_serviceClinicNames;

    const regex = new RegExp(text, "gi");
    return this.cx_serviceClinicNames.filter((el) => {
      return el.name.match(regex) != null;
    });
  }

  selectServiceClinicName(serviceClinicName: ServiceInterface): void {
    this.cx_selectedServiceClinicName = serviceClinicName;
    this.$emit("changeServiceClinicName", this.cx_selectedServiceClinicName);
    this.toogleSearchModal();
  }

  formatCurrency(str: string): string {
    return parseFloat(str).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  returnHome() {
    if (this.$route.name == "ClinicScreen") {
      this.$router.push({ name: "ClinicScreen" });
    } else {
      this.$router.push({ name: "Home" });
    }
  }
}
